enum ProjectLevel  {
    FocalPoint = 1,
    ProjectManager = 2,
    ProjectOwner = 3,
    GateKeeper = 4,
    TeamMember = 5,
    Secretary= 7
}

export default ProjectLevel